module.exports = __webpack_public_path__ + "static/media/red_cross.f1b5e4cd.svg";